'use client'

import { HomeSearchContext, useHomeSearchState } from '@homeSearch/modules/context'
import { fetchNewHomes } from '@homeSearch/modules/fetch'
import HomeSearchInput from '@homeSearch/modules/input'
import Location from '@homeSearch/modules/location'
import HomeSearchPopup from '@homeSearch/modules/popup'
import useProgressRouter from '@hooks/useProgressRouter'
import { searchDataLayer } from '@plugin/google/gtm/modules/builder'
import getBuilderRoute from '@plugin/searchRoute/modules/builder'
import { builderList } from '@router'
import { size } from 'lodash-es'
import { Suspense, useCallback, useEffect } from 'react'

export default function BuilderSearch({
  state,
  suburbs
}) {

  const searchState = useHomeSearchState({
    oneSuburb: false,
    recentSuburb: false,
  })
  const { setSuburbs } = searchState

  useEffect(() => {
    setSuburbs(suburbs)
  }, [suburbs, state, setSuburbs])

  // 选择城区
  const { replaceRouter } = useProgressRouter()
  const searchHandle = useCallback(({ suburbs }) => {
    if (!size(suburbs)) return
    const { slug } = state

    const builderRoute = getBuilderRoute()
    builderRoute.fromSlug(slug)
    builderRoute.clearSuburbs()
    builderRoute.setSuburbs(suburbs)
    const newSlug = builderRoute.toSlug()
    if (newSlug !== slug) {
      searchDataLayer.search()
      replaceRouter(builderList(newSlug))
    }
  }, [state, replaceRouter])

  return (
    <HomeSearchContext.Provider value={searchState}>
      <Suspense>
        <HomeSearchInput onSearch={searchHandle}>
          <HomeSearchPopup showSurround={false} fetcher={fetchNewHomes}></HomeSearchPopup>
        </HomeSearchInput>
      </Suspense>
      <Location></Location>
    </HomeSearchContext.Provider>
  )
}
